import { IAccBienLaiThietLap } from "../../model/respone/category/IAccBienLaiThietLap";
import { ICauHinhSoPhieu } from "../../model/respone/category/ICauHinhSoPhieu";
import { apiClient } from "../apiClient";
export const BIEN_LAI_THIET_LAP_ENDPOINT = "bien-lai-thiet-lap";
export const bienLaiThietLapApi = {
  SelectAll: () => apiClient.get(`${BIEN_LAI_THIET_LAP_ENDPOINT}`),
  Insert: (payload: IAccBienLaiThietLap) =>
    apiClient.post(`${BIEN_LAI_THIET_LAP_ENDPOINT}`, payload),
  Update: (payload: IAccBienLaiThietLap) =>
    apiClient.put(`${BIEN_LAI_THIET_LAP_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${BIEN_LAI_THIET_LAP_ENDPOINT}/${id}`),
  // Cấu hình đánh số phiếu toàn cục (xê-ri, độ dài, số bắt đầu, reset theo năm, tách chi)
  GetCauHinhSoPhieu: () =>
    apiClient.get(`${BIEN_LAI_THIET_LAP_ENDPOINT}/cau-hinh/so-phieu`),
  SetCauHinhSoPhieu: (payload: ICauHinhSoPhieu) =>
    apiClient.put(`${BIEN_LAI_THIET_LAP_ENDPOINT}/cau-hinh/so-phieu`, payload),
};
